import adminApprovalCertificatesTemplate from './certificates/template.html';
import AdminApprovalCertificatesCtrl from './certificates';
import AdminApprovalApprovalsNavCtrl from './nav';
import adminApprovalNavTemplate from './nav/template.html';

const adminApprovalsState = {
  url: '/approvals',
  abstract: true,
  views: {
    'a@app': {
      template: adminApprovalNavTemplate,
      controller: AdminApprovalApprovalsNavCtrl,
      controllerAs: 'adminApprovalTabsCtrl'
    }
  }
};

const adminApprovalsCertificatesState = {
  url: '/certificates',
  stateName: 'CPE Approvals',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/admin/approvals/certificates')
  },
  views: {
    a: {
      template: adminApprovalCertificatesTemplate,
      controller: AdminApprovalCertificatesCtrl,
      controllerAs: 'certApprovalsCtrl'
    }
  }
};

const adminApprovalsReportState = {
  url: '/cpe-requests?search&page&pageSize',
  stateName: 'CPE Requests',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/admin/approvals/cpe-requests')
  },
  reloadOnSearch: false,
  params: {
    search: {
      value: undefined,
      type: 'string'
    },
    pageSize: {
      type: 'int',
      value: undefined
    },
    page: {
      type: 'int',
      value: undefined
    }
  },
  views: {
    a: {
      template: '<cpe-requests></cpe-requests>'
    }
  }
};

export { adminApprovalsState, adminApprovalsCertificatesState, adminApprovalsReportState };



// WEBPACK FOOTER //
// ./src/app/controllers/admin/approvals/index.js